import ProductiveSquare from "./ProductiveSquare";
import { ContainerProd } from "./ProductiveSquare/styles";
import { CircularProgress } from "@material-ui/core";

const Productivity = ({ dashTasks }) => {
  const LoadingIndicator = () => (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <CircularProgress />
    </div>
  );

  //? Finaly Creating the Implementation
  const monthlyData = [];
  const weeklyData = [];
  const generalData = [];
  let Carregado = false;

  // Determinando o TimeFrame no momento so o semanal e mensal atual serão levados em consideração.
  const getStartOfWeek = () => {
    const now = new Date();
    const firstDayOfWeek = new Date(
      now.setDate(now.getDate() - now.getDay() + (now.getDay() === 0 ? -6 : 1))
    ); // Adjust to your week start day
    firstDayOfWeek.setHours(0, 0, 0, 0);
    return firstDayOfWeek;
  };

  const getStartOfMonth = () => {
    const now = new Date();
    return new Date(now.getFullYear(), now.getMonth(), 1);
  };

  const getMonthTimeFrame = (year, month) => {
    const startOfMonth = new Date(year, month, 1);
    const endOfMonth = new Date(year, month + 1, 0, 23, 59, 59, 999); // Last moment of the month
    return { startOfMonth, endOfMonth };
  };

  //? Validando as Tasks a serem escolhidas unico metodo de criação no moment são os limitados a até o dia atual

  const processTasksToDay = (tasks, startTime, endTime) => {
    // This function now filters tasks based on their completion date, ensuring they fall within the given timeframe.
    return tasks.filter((task) => {
      const finishedAt = new Date(task.data.finishedAt);
      return finishedAt >= startTime && finishedAt <= endTime;
    });
  };

  //? Calcular Produtividade dos Trabalhadores

  const calculateProductivity = (doneTasks, doneLateTasks, lateTasks) => {
    let totalEstimatedDuration = 0;
    let totalActualDuration = 0;

    doneTasks.forEach((task) => {
      totalEstimatedDuration += task.data.expiration.number;
      totalActualDuration +=
        task.data.expiration.number - task.moment.diffHours;
    });

    doneLateTasks.forEach((task) => {
      totalEstimatedDuration += task.data.expiration.number;
      totalActualDuration +=
        task.data.expiration.number - task.moment.diffHours;
    });

    lateTasks.forEach((lateTask) => {
      totalActualDuration += -lateTask.moment.diffHours;
    });

    // Calculate productivity
    let productivity =
      totalActualDuration === 0
        ? 0
        : (totalEstimatedDuration / totalActualDuration) * 100;

    // Ensure productivity doesn't fall below zero
    //! A ser modificado
    productivity = Math.min(Math.max(Math.round(productivity), 0), 100);

    return productivity;
  };

  //? Popular as Listas

  const populateData = (data) => {
    const startOfWeek = getStartOfWeek();
    const startOfMonth = getStartOfMonth();
    const now = new Date(); // Assuming you want to count up to the current date

    const weekDoneTasks = processTasksToDay(data.done, startOfWeek, now);
    const weekDoneLateTasks = processTasksToDay(
      data.doneLate,
      startOfWeek,
      now
    );

    weeklyData.push({
      doingTasks: data?.doing.length,
      lateTasks: data?.late.length,
      pendingTasks: data?.pending.length,
      nonAccTasks: data?.nonAcc.length,
      doneTasks: weekDoneTasks.length,
      doneLateTasks: weekDoneLateTasks.length,
      productivity: calculateProductivity(
        weekDoneTasks,
        weekDoneLateTasks,
        data.late
      ),
    });

    const monthlyDoneTasks = processTasksToDay(data.done, startOfMonth, now);
    const monthlyDoneLateTasks = processTasksToDay(
      data.doneLate,
      startOfMonth,
      now
    );

    monthlyData.push({
      doingTasks: data?.doing.length,
      lateTasks: data?.late.length,
      pendingTasks: data?.pending.length,
      nonAccTasks: data?.nonAcc.length,
      doneTasks: monthlyDoneTasks.length,
      doneLateTasks: monthlyDoneLateTasks.length,
      productivity: calculateProductivity(
        monthlyDoneTasks,
        monthlyDoneLateTasks,
        data.late
      ),
    });

    generalData.push({
      doingTasks: data?.doing.length,
      lateTasks: data?.late.length,
      pendingTasks: data?.pending.length,
      nonAccTasks: data?.nonAcc.length,
      doneTasks: data.done.length,
      doneLateTasks: data.doneLate.length,
      productivity: calculateProductivity(data.done, data.doneLate, data.late),
    });
  };

  if (dashTasks.status === "succeeded") {
    populateData(dashTasks.data);
    Carregado = true;
  }

  return dashTasks.status === "succeeded" && Carregado === true ? (
    <ProductiveSquare
      //! General Block
      TGDelayed={generalData[0].lateTasks}
      TGPending={generalData[0].pendingTasks}
      TGExecution={generalData[0].doingTasks}
      TGConcluded={generalData[0].doneTasks}
      TGNotDelegated={generalData[0].nonAccTasks}
      TGDeConcluded={generalData[0].doneLateTasks}
      TGPointer={generalData[0].productivity}
      //! Weekly Block (Semanal)
      TSDelayed={weeklyData[0].lateTasks}
      TSPending={weeklyData[0].pendingTasks}
      TSExecution={weeklyData[0].doingTasks}
      TSConcluded={weeklyData[0].doneTasks}
      TSNotDelegated={weeklyData[0].nonAccTasks}
      TSDeConcluded={weeklyData[0].doneLateTasks}
      TSPointer={weeklyData[0].productivity}
      //! Monthly Block (Mensal)
      TMDelayed={monthlyData[0].lateTasks}
      TMPending={monthlyData[0].pendingTasks}
      TMExecution={monthlyData[0].doingTasks}
      TMConcluded={monthlyData[0].doneTasks}
      TMNotDelegated={monthlyData[0].nonAccTasks}
      TMDeConcluded={monthlyData[0].doneLateTasks}
      TMPointer={monthlyData[0].productivity}
    />
  ) : (
    <ContainerProd>
      <h4>Carregando</h4>
      <LoadingIndicator />
    </ContainerProd>
  );
};

export default Productivity;
